import type { AppEnvironment } from '@core/config/app-environment';

export const environment: AppEnvironment = {
  production: false,
  appName: 'KSSAP Dashboard',
  // Shared develop API. Must be https — http often fails in the browser as status 0 (Unknown Error).
  apiBaseUrl: 'https://api.dev.ksap.app/',
  defaultLanguage: 'en',
  tokenStorageKey: 'kssap.access-token',
  pageSize: 20,
};
